import { render } from "./Card.vue?vue&type=template&id=1f3a0fa4&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=1f3a0fa4&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3a0fa4"]])

export default __exports__